import React, { useEffect, useState } from "react";
import api from "../utils/api.js";
import { URLS,ImgURL } from "../utils/urls.js";
import { User, Eye, Trash2, Plus, X } from "lucide-react";
import Tooltip from "../components/Tooltip.jsx";

const AdminsPage = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [newPassword, setNewPassword] = useState("");
    const [updating, setUpdating] = useState(false);

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newAdmin, setNewAdmin] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "admin",
    phone:""
  });

const fetchAdmins = async () => {
      try {
        setLoading(true);
        const res = await api.get(URLS.GET_ADMINS);
        setAdmins(res.data || []);
      } catch (err) {
        setError("Failed to load admins.");
      } finally {
        setLoading(false);
      }
    };
  // Fetch admins
  useEffect(() => {

    fetchAdmins();
  }, []);


    // Get profile image or fallback to ui-avatars
  const getProfileImage = (admin) => {
    if (admin.profileImage) return admin.profileImage;
    const name = `${admin.firstName || ""} ${admin.lastName || ""}`.trim();
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(
      name || "U"
    )}&background=db8654&color=fff`;
  };

  // Delete admin
  const handleDeleteAdmin = async (id) => {
    if (!window.confirm("Are you sure you want to delete this admin?")) return;
    try {
      await api.delete(URLS.DELETE_ADMIN(id));
      setAdmins((prev) => prev.filter((a) => a.id !== id));
      alert("Admin deleted successfully!");
    } catch (err) {
      alert("Failed to delete admin.");
    }
  };

  // View admin profile
  const handleViewAdmin = (admin) => {
    setSelectedAdmin(admin);
    setIsViewModalOpen(true);
  };

  // Handle Add Admin
  const handleAddAdmin = async (e) => {
    e.preventDefault();
    console.log("data is ", newAdmin)
    try {
      const res = await api.post(URLS.CREATE_ADMIN, newAdmin);
      fetchAdmins();
      alert("Admin created successfully!");
      setIsAddModalOpen(false);
      setNewAdmin({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        role: "admin",
      });
    } catch (err) {
      alert("Failed to create admin.");
    }
  };


    // Update admin password
  const handlePasswordUpdate = async () => {
    if (!newPassword.trim()) {
      alert("Please enter a password.");
      return;
    }
    try {
      setUpdating(true);
      await api.patch(URLS.UPDATE_ADMIN(selectedAdmin.id), {
        password: newPassword,
      });
      alert("Password updated successfully!");
      setNewPassword("");
      setIsViewModalOpen(false)
    } catch (err) {
      alert("Failed to update password.");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="p-2 bg-gray-100 min-h-screen font-sans">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
          Admin Users
        </h2>
        <button
          onClick={() => setIsAddModalOpen(true)}
          className="flex items-center gap-2 px-4 py-2 bg-[#db8654] hover:bg-[#c67442] text-white rounded-lg shadow transition"
        >
          <Plus size={18} />
          Add User
        </button>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl shadow-lg overflow-x-auto">
        {loading && (
          <div className="p-8 text-center text-gray-500">Loading admins...</div>
        )}
        {error && <div className="p-8 text-center text-red-500">{error}</div>}
        {!loading && !error && (
          <table className="min-w-[800px] w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-2 sm:p-4 text-left text-xs sm:text-sm font-semibold text-gray-500 uppercase min-w-[200px]">
                  Name
                </th>
                <th className="p-2 sm:p-4 text-left text-xs sm:text-sm font-semibold text-gray-500 uppercase min-w-[200px]">
                  Email
                </th>
                <th className="p-2 sm:p-4 text-left text-xs sm:text-sm font-semibold text-gray-500 uppercase min-w-[120px]">
                  Role
                </th>
                <th className="p-2 sm:p-4 text-left text-xs sm:text-sm font-semibold text-gray-500 uppercase min-w-[180px]">
                  Last Login
                </th>
                <th className="p-2 sm:p-4 text-left text-xs sm:text-sm font-semibold text-gray-500 uppercase min-w-[180px]">
                  Last Active
                </th>
                <th className="p-2 sm:p-4 text-center text-xs sm:text-sm font-semibold text-gray-500 uppercase min-w-[120px]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {admins.length > 0 ? (
                admins.map((admin) => (
                  <tr
                    key={admin.id}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    {/* Name */}
                    <td className="p-2 sm:p-4">
                      <div className="flex items-center gap-2 sm:gap-3">
                        {admin.profileImage ? (
                          <img
                            className="h-8 w-8 sm:h-10 sm:w-10 rounded-full object-cover border"
                            src={ImgURL(admin.profileImage)}
                            alt={admin.firstName}
                          />
                        ) : (
                          <img
                            className="h-8 w-8 sm:h-10 sm:w-10 rounded-full object-cover border"
                            src={`https://ui-avatars.com/api/?name=${admin.firstName}+${admin.lastName}&background=db8654&color=fff`}
                            alt={admin.firstName}
                          />
                        )}
                        <div className="truncate">
                          <p className="text-gray-900 font-medium text-sm sm:text-base">
                            {admin.firstName} {admin.lastName}
                          </p>
                          <p className="text-gray-500 text-xs sm:text-sm truncate">
                            {admin.phone || "No phone"}
                          </p>
                        </div>
                      </div>
                    </td>

                    {/* Email */}
                    <td className="p-2 sm:p-4 text-gray-600 text-sm sm:text-base">
                      {admin.email}
                    </td>

                    {/* Role */}
                    <td className="p-2 sm:p-4 text-gray-600 text-sm sm:text-base">
                      {admin.role}
                    </td>

                    {/* Last Login */}
                    <td className="p-2 sm:p-4 text-gray-500 text-sm sm:text-base whitespace-nowrap">
                      {admin.lastLogin
                        ? new Date(admin.lastLogin).toLocaleString()
                        : "Never"}
                    </td>

                    {/* Last Active */}
                    <td className="p-2 sm:p-4 text-gray-500 text-sm sm:text-base whitespace-nowrap">
                      {admin.lastActive
                        ? new Date(admin.lastActive).toLocaleString()
                        : "Never"}
                    </td>

                    {/* Actions */}
                    <td className="p-2 sm:p-4 text-center flex items-center gap-3 justify-center">
                      <Tooltip text="View">
                        <button
                          onClick={() => handleViewAdmin(admin)}
                          className="p-2 rounded-full bg-blue-50 hover:bg-blue-100 text-blue-600 transition"
                        >
                          <Eye size={18} />
                        </button>
                      </Tooltip>
                      <Tooltip text="Delete">
                        <button
                          onClick={() => handleDeleteAdmin(admin.id)}
                          className="p-2 rounded-full bg-red-50 hover:bg-red-100 text-red-600 transition"
                        >
                          <Trash2 size={18} />
                        </button>
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center p-4 text-gray-500 text-sm sm:text-base"
                  >
                    No admins found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* View Modal */}
      {isViewModalOpen && selectedAdmin && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-full max-w-lg p-6 relative">
            {/* Close Button */}
            <button
              onClick={() => {
                setSelectedAdmin(null);
                setIsViewModalOpen(false);
              }}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X size={20} />
            </button>

            {/* Profile */}
            <div className="flex flex-col items-center text-center">
              <img
                src={ImgURL(getProfileImage(selectedAdmin))}
                alt="Profile"
                className="w-20 h-20 rounded-full object-cover border mb-3"
              />
              <h3 className="text-xl font-semibold text-gray-800">
                {selectedAdmin.firstName} {selectedAdmin.lastName}
              </h3>
              <p className="text-gray-500">{selectedAdmin.email}</p>
              <span className="mt-2 px-3 py-1 text-sm rounded-full bg-[#db8654]/20 text-[#db8654]">
                {selectedAdmin.role}
              </span>
            </div>

            {/* Details */}
            <div className="mt-6 space-y-2 text-sm text-gray-600">
              <p>
                <strong>Phone:</strong>{" "}
                {selectedAdmin.phone || "Not Provided"}
              </p>
              <p>
                <strong>Last Login:</strong>{" "}
                {selectedAdmin.lastLogin
                  ? new Date(selectedAdmin.lastLogin).toLocaleString()
                  : "Never"}
              </p>
              <p>
                <strong>Last Active:</strong>{" "}
                {selectedAdmin.lastActive
                  ? new Date(selectedAdmin.lastActive).toLocaleString()
                  : "Never"}
              </p>
              <p>
                <strong>Created:</strong>{" "}
                {new Date(selectedAdmin.createdAt).toLocaleDateString()}
              </p>
            </div>

            {/* Password Update */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Update Password
              </label>
              <div className="flex gap-2">
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#db8654]/50"
                />
                <button
                  onClick={handlePasswordUpdate}
                  disabled={updating}
                  className="px-4 py-2 bg-[#db8654] text-white rounded-lg hover:opacity-90 transition disabled:opacity-50"
                >
                  {updating ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-6 relative">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">
              Add New Admin
            </h3>
            <form onSubmit={handleAddAdmin} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  First Name
                </label>
                <input
                  type="text"
                  value={newAdmin.firstName}
                  onChange={(e) =>
                    setNewAdmin({ ...newAdmin, firstName: e.target.value })
                  }
                  className="mt-1 block w-full border rounded-lg px-3 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Last Name
                </label>
                <input
                  type="text"
                  value={newAdmin.lastName}
                  onChange={(e) =>
                    setNewAdmin({ ...newAdmin, lastName: e.target.value })
                  }
                  className="mt-1 block w-full border rounded-lg px-3 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  value={newAdmin.email}
                  onChange={(e) =>
                    setNewAdmin({ ...newAdmin, email: e.target.value })
                  }
                  className="mt-1 block w-full border rounded-lg px-3 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  type="password"
                  value={newAdmin.password}
                  onChange={(e) =>
                    setNewAdmin({ ...newAdmin, password: e.target.value })
                  }
                  className="mt-1 block w-full border rounded-lg px-3 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Role
                </label>
                <select
                  value={newAdmin.role}
                  onChange={(e) =>
                    setNewAdmin({ ...newAdmin, role: e.target.value })
                  }
                  className="mt-1 block w-full border rounded-lg px-3 py-2"
                >
                  <option value="admin">Admin</option>
                  <option value="manager">Manager</option>
                  <option value="editor">Editor</option>
                </select>
              </div>
              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => setIsAddModalOpen(false)}
                  className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#db8654] text-white rounded-lg hover:bg-[#c67442] transition"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminsPage;
